import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState({
      filter: ({ filtersStore: { filter } }) => filter,
      queries: ({ resourcesStore: { queries } }) => queries,
    }),
  },
  methods: {
    activateTypeFilter(type, id, title) {
      this.$store.commit('filtersStore/reset', type);
      let filterQuery = {
        type: type,
        id: id,
        title: title,
      };

      let updateQuery = JSON.parse(JSON.stringify(this.queries.videos));

      if (updateQuery.filters.products) {
        delete updateQuery.filters.products;
      }
      if (updateQuery.filters.recurring_from) {
        delete updateQuery.filters.recurring_from;
      }
      const currentFilters = updateQuery.filters;
      if (id === 'free') {
        updateQuery.filters = {
          ...currentFilters,
          [type]: { 0: id },
        };
      }
      if (id === 'direct') {
        type = 'recurring_from';
        id = this.getTodayDate();
        updateQuery.sort = {
          [type]: 'desc',
        };
        updateQuery.filters = {
          ...currentFilters,
          [type]: { 0: 'before,' + id },
        };
      }
      if (id === 'huren') {
        type = 'recurring_from';
        id = this.getTomorrowDate();
        updateQuery.sort = {
          [type]: 'asc',
        };
        updateQuery.filters = {
          ...currentFilters,
          [type]: { 0: 'after,' + id },
        };
      }

      updateQuery.pagination.page = 1;

      this.$store.commit('filtersStore/setFilter', filterQuery);
      this.$store.commit('resourcesStore/updateQuery', updateQuery);
      this.$store.dispatch('resourcesStore/getResources', updateQuery);

      if (!this.isMobile) {
        this.$store.commit('dropdownStore/setDropdown', false);
      }
    },

    getTodayDate() {
      const today = new Date();
      today.setDate(today.getDate());
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    getTomorrowDate() {
      const today = new Date();
      today.setDate(today.getDate() + 1);
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
  },
};
